import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import {
  SET_ENCODING,
  SET_ENTRY_FORMAT,
  SET_FORMAT_ID,
  SET_PRINTER_ID,
  SET_SCALES,
} from '../../../store/reducers/printer'
import { RootState } from '../../../store/reducers/rootReducer'
import useDataFetcher from '../../main/second/mainbar/knisot/hooks/useFetchData'
import { Defaults } from '../../modules/API/Defaults/defaults'
import { IPrintersResponseNode } from '../../modules/API/Defaults/models/printers'
import { FormField, FormGrid } from '../ui/FormLayout'
import PrintFormatSelector, {
  ENTRY_FORMAT_OPTIONS,
  PALLET_FORMAT_OPTIONS,
} from '../ui/Selectors/PrintFormatSelector'
import PrinterSelector from '../ui/Selectors/PrinterSelector'
import ScalesSelector from '../ui/Selectors/ScalesSelector'
import ZplEncodingSelector, { ZplEncodingValue } from '../ui/Selectors/ZplEncodingSelector'

const PrinterSettingsModal = () => {
  const dispatch = useDispatch()
  const printerState = useSelector((state: RootState) => state.printerReducer)

  const { data: printersList } = useDataFetcher<IPrintersResponseNode>(
    Defaults.getPrinters,
    'data',
  )

  const printers = printersList?.printers || []
  const weights = printersList?.weights || []

  const selectedPrinter = useMemo(
    () => printers.find((p) => p.NumWeight === printerState.printerID) ?? null,
    [printers, printerState.printerID],
  )
  const selectedScale = useMemo(
    () => weights.find((w) => w.NumWeight === printerState.scales) ?? null,
    [weights, printerState.scales],
  )

  return (
    <Wrapper>
      <FormGrid>
        <FormField label='בחר מדפסת' fullWidth>
          <PrinterSelector
            printers={printers}
            value={selectedPrinter}
            onSelect={(printer) =>
              dispatch({ type: SET_PRINTER_ID, payload: printer?.NumWeight ?? null })
            }
          />
        </FormField>

        <FormField label='פורמט משטח'>
          <PrintFormatSelector
            options={PALLET_FORMAT_OPTIONS}
            value={printerState.formatID}
            onSelect={(value) => dispatch({ type: SET_FORMAT_ID, payload: value })}
            placeholder='בחר פורמט משטח'
          />
        </FormField>

        <FormField label='פורמט כניסה'>
          <PrintFormatSelector
            options={ENTRY_FORMAT_OPTIONS}
            value={printerState.entryFormat}
            onSelect={(value) => dispatch({ type: SET_ENTRY_FORMAT, payload: value })}
            placeholder='בחר פורמט כניסה'
          />
        </FormField>

        <FormField label='משקל'>
          <ScalesSelector
            scales={weights}
            value={selectedScale}
            onSelect={(scale) =>
              dispatch({ type: SET_SCALES, payload: scale?.NumWeight ?? 0 })
            }
          />
        </FormField>

        <FormField label='קידוד'>
          <ZplEncodingSelector
            value={printerState.encoding}
            onSelect={(value: ZplEncodingValue) =>
              dispatch({ type: SET_ENCODING, payload: value })
            }
          />
        </FormField>
      </FormGrid>
    </Wrapper>
  )
}

export default PrinterSettingsModal

const Wrapper = styled.div`
  width: 100%;
  padding: 0.25rem;
  direction: rtl;
`
